<template>
  <router-view></router-view>
</template>

<script>
  export default {
    data: () => ({
      globalStorage: JSON.parse(localStorage.getItem('globalStorage')) || {}
    }),

    provide() {
      return {
        globalStorage: this.globalStorage,
        updateGlobalStorage: (key, val) => {
          if (typeof key === 'object') {
            this.globalStorage = key;
          } else {
            this.globalStorage[ key ] = val;
          }
          localStorage.setItem('globalStorage', JSON.stringify(this.globalStorage));
        }
      };
    },

  };
</script>
